module.exports = __webpack_public_path__ + "static/media/img_pop_home.a5acfffe.svg";